import { createUrl } from './create-url';

export const getMyBusinessUrl = (url: string): string => {
    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;

    if (
        /bedrift\.if\.no/.test(hostname) ||
        /foretag\.if\.se/.test(hostname) ||
        /yritys\.if\.fi/.test(hostname) ||
        /erhverv\.if\.dk/.test(hostname)
    ) {
        return page.origin;
    }

    return '';
};
